import React from 'react';
import { Table } from 'reactstrap';
import moment from 'moment-timezone';
const OrderTax = props => {
  return (
    <Table responsive hover className="ps-table tb-col-4">
      <thead>
        <tr>
          <th>Name</th>
          <th>Rate(%)</th>
          <th>Amount</th>
          <th>Datetime</th>
        </tr>
      </thead>
      <tbody>
        {props.state.tax_items.length < 1 && (
          <tr>
            <td colSpan="4">
              <div className="ps-empty-data">
                <div className="empty-content">
                  <h4>No data to show</h4>
                </div>
              </div>
            </td>
          </tr>
        )}

        {props.state.tax_items.length > 0 &&
          props.state.tax_items.map((item, index) => {
            return (
              <tr key={index}>
                <td>{item.name}</td>
                <td>{item.rate}</td>
                <td>{item.amount}</td>
                <td>
                  {moment(item.datetime)
                    .tz('Asia/Singapore')
                    .format('YYYY-MM-DD hh:mm:ss A')}
                </td>
              </tr>
            );
          })}
      </tbody>
    </Table>
  );
};

export default OrderTax;
